import { rgba } from 'polished'
import { FaUserGraduate } from 'react-icons/fa'
import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 26rem;
  margin: 0 auto;
`

export const PhotoWrapper = styled.div`
  width: 148px;
  height: 148px;
  padding: 0.35rem;
  margin-bottom: 1rem;
  border-radius: 50%;
  background: linear-gradient(180deg, #f3f6fb 0%, #e8edf5 100%);
`

export const Photo = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
`

export const PhotoFallback = styled(FaUserGraduate)`
  width: 72px;
  height: 72px;
  color: ${props => rgba(props.theme.colors.textPrimary, 0.42)};
`

export const Name = styled.h3`
  width: 100%;
  margin-bottom: 0.75rem;
  color: ${props => props.theme.colors.textPrimary};
  font-size: 1.85rem;
  line-height: 1.25;
  text-align: center;
  overflow-wrap: anywhere;
  word-break: break-word;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`

export const Badge = styled.span`
  width: 100%;
  margin-bottom: 1.5rem;
  padding: 0.45rem 0.9rem;
  border-radius: 999px;
  background-color: ${props => rgba(props.theme.colors.primary, 0.1)};
  color: ${props => props.theme.colors.primary};
  font-weight: 600;
  text-align: center;
  overflow-wrap: anywhere;
`

export const DetailsList = styled.div`
  width: 100%;
  border: 1px solid ${props => rgba(props.theme.colors.textPrimary, 0.12)};
  border-radius: 0.75rem;
  overflow: hidden;
  background-color: ${props => props.theme.colors.background};
`

export const DetailItem = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid
    ${props => rgba(props.theme.colors.textPrimary, 0.08)};

  &:last-child {
    border-bottom: 0;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const DetailLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: ${props => rgba(props.theme.colors.textPrimary, 0.8)};
  font-weight: 500;
`

export const DetailValue = styled.span`
  color: ${props => props.theme.colors.textPrimary};
  font-weight: 600;
  text-align: right;

  @media (max-width: 576px) {
    text-align: left;
  }
`
